export const GROUP_LIST_LINK_DATA_HOOK = 'sidebar group list link';
